import {
  AudioHighlightMetadata,
  AudioHighlightMetadataType,
} from '@modules/feedback/components/AudioType/types';
import { getBookmarkColor } from '@modules/feedback/components/AudioType/utils/getBookmarkColor';
import { alpha, lighten, SxProps } from '@mui/material';
import { Theme } from '@mui/system';

interface GetBookmarkStylesOptions {
  theme: Theme;
  highlight: AudioHighlightMetadata;
  duration: number;
  zIndex?: number;
  isDisabled?: boolean;
  backgroundColor?: string;
}

export const getBookmarkStyles = (
  options: GetBookmarkStylesOptions,
): SxProps<Theme> => {
  const {
    theme,
    highlight,
    duration,
    zIndex = 1,
    isDisabled = false,
    backgroundColor: backgroundColorProp,
  } = options;

  const isReasonSummaryType =
    highlight.type === AudioHighlightMetadataType.ReasonSummary;

  const leftPositionPercentage = (highlight.startTime / duration) * 100;
  const widthPercentage =
    ((highlight.endTime - highlight.startTime) / duration) * 100;

  const backgroundColor =
    backgroundColorProp || getBookmarkColor(highlight, theme);

  return {
    left: `${leftPositionPercentage}%`,
    width: `${widthPercentage}%`,
    position: 'absolute',
    height: isReasonSummaryType ? '17px' : '10px',
    backgroundColor: alpha(backgroundColor, isReasonSummaryType ? 1 : 0.8),
    zIndex: isReasonSummaryType ? zIndex - 1 : zIndex,
    boxShadow: `0 0 0 0.7px ${lighten(theme.palette.primary.main, 0.9)}`,
    borderRadius: '1px',
    '&:hover': {
      height: isReasonSummaryType ? '20px' : '12px',
      borderRadius: '2px',
      backgroundColor,
      cursor: isDisabled ? 'default' : 'pointer',
      boxShadow: '0 0 0 1.5px #FFF',
      zIndex: isReasonSummaryType ? zIndex - 1 : 3,
    },
  };
};
